// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
    production: false,

    /*Production Settings */
    apiUrl: 'https://legacy.argic.org/',  
    localUrl: 'https://www.argic.org/',
    apiWizardUrl: 'https://www.argic.org/', 

    /* Dev settings */
    // apiUrl: "https://legacy.argic.org/", //needed for registration
    // localUrl: "https://localhost:44300/",
    // apiWizardUrl: "https://localhost:44300/",

    assetsInfo: "/assets/docs/information/",
};